/**
 * Links to a property's details page carry the search the user came from
 * (`?previousUrl=`).
 *
 * From a details page that is the search this page came from, not this page:
 * wrapping the whole address again at every hop roughly doubled it, and past
 * ~2 KB of query string the edge firewall answers 403 "Request blocked"
 * (client recording 2026-10-27, moving from house to house to pin them).
 */
export function previousUrlFor(location = window.location) {
  if (location.pathname.startsWith('/property-details/')) {
    const inherited = new URLSearchParams(location.search).get('previousUrl');
    if (inherited) {
      return inherited;
    }
  }

  return location.href;
}

export function propertyDetailsPath(propertyId, location = window.location) {
  return `/property-details/${propertyId}/?previousUrl=${encodeURIComponent(previousUrlFor(location))}`;
}
